import { computed, ref } from 'vue';
import { useChooserFormStore } from './forms/chooser';
import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia';

/**
 * This store contains data for section navigation
 */
export const useSectionStore = defineStore('section', () => {
    const formStore = useChooserFormStore();
    const { regionAndOccupationReady } = storeToRefs(formStore);

    const current = ref(1);
    const length = ref(3);

    const nextButtonEnabled = computed(() => {
        if (current.value === 1) {
            return regionAndOccupationReady.value;
        }
        return true;
    });

    function nextSection() {
        current.value++;
    }
    function previousSection() {
        current.value--;
    }

    return {
        current,
        length,
        nextButtonEnabled,
        nextSection,
        previousSection,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSectionStore, import.meta.hot));
}
